export default {
  allMsg: 'Alle Nachrichten',
  systemMsg: 'Systemnachrichten',
  personMsg: 'Manuelle Nachrichten',
  unread: 'Ungelesen',
  seeDetail: 'Details anzeigen',
  read: 'Gelesen',
  replyNow: 'jetzt antworten',
  message: 'Nachricht',
  operateSuccess: 'Erfolgreich ausgeführt',
  holder: {
    searchHolder: 'Paketnummer/Bestellnummer/Artikelnummer',
  },
  addAcBuy: 'Treten Sie AcBuy Discord bei & gewinnen Sie 2000 ¥ CASH!',
  joinNow: 'Hier beitreten',
  flatActivity: 'Teilen Sie, wie Sie auf Taobao & AcBuy einkaufen – gewinnen Sie 1500 ¥ CASH!',
  joinNow1: 'Jetzt mitmachen',
  tips1: 'Offizielles Labubu-Gewinnspiel von Acbuy',
  tips2: 'Riesiges Labubu-Gewinnspiel & komplettes ZIMOMO-Set zu gewinnen',
}
